import { useEffect, useState } from 'react';

type RedirectResult = {
    shouldRedirect: boolean;
    redirectUrl?: string;
};

type RedirectLoaderProps = {
    children: JSX.Element;
};

const RedirectLoader = ({ children }: RedirectLoaderProps) => {
    const [ready, setReady] = useState(false);

    useEffect(() => {
        const doRedirectCheck = async () => {
            const redirected = await checkRedirectFromCurrentURL();
            if (!redirected) setReady(true);
        };

        doRedirectCheck();
    }, []);

    return ready ? children : null; // Can replace null with a spinner if needed
};

export default RedirectLoader;

// ------------------------
// Exported Helpers Below
// ------------------------

/**
 * Run redirect logic using current browser location and query params.
 */
export const checkRedirectFromCurrentURL = async (): Promise<boolean> => {
    const searchParams = new URLSearchParams(window.location.search);
    const lang = searchParams.get("lang");
    const rd = searchParams.get("rd");
    const path = window.location.pathname;

    return await checkRedirect({ path, lang, rd });
};


export const checkRedirect = async ({
    path,
    rd,
    lang
}: {
    path: string;
    rd?: string | null;
    lang?: string | null;
}): Promise<boolean> => {
    try {
        const response = await fetch("api/video/shouldredirect", {
            method: "POST",
            body: JSON.stringify({ path, rd, lang}),
            headers: {
                "Content-Type": "application/json"
            },
            credentials: "same-origin"
        });

        const result: RedirectResult = await response.json();

        if (result.shouldRedirect && result.redirectUrl) {
            window.location.href = result.redirectUrl;
            return true;
        }

        return false;
    } catch (err) {
        console.error("Redirect check failed:", err);
        return false;
    }
};
